export const CURRENCY_CODE = {
    KRW : "KRW",
    USD : "USD",
}